import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { LaboratoryView, getLaboratoryOptions } from '@/module/Laboratory';

export const Route = createFileRoute(
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { labId } = Route.useParams();
  const { data: laboratory } = useSuspenseQuery(getLaboratoryOptions(labId));

  return <LaboratoryView laboratory={laboratory} />;
}
